// Dialog-specific types for Mechanical Contractor management

export interface LocalTradeSelection {
  localUnionId: string;
  localUnionName: string;
  tradeIds: string[];
  unionType: 'union' | 'non-union' | 'mixed';
}

export interface MechanicalContractorFormData {
  name: string;
  status: 'active' | 'inactive';
  address: string;
  city: string;
  province: string;
  postalCode: string;
  coordinates?: number[];
  subOffices: {
    address: string;
    city: string;
    province: string;
    postalCode: string;
    coordinates?: [number, number];
  }[];
  localTradeSelections: LocalTradeSelection[];
}

export interface MechanicalContractorFormErrors {
  name: string;
  status: string;
  address: string;
  city: string;
  province: string;
  postalCode: string;
  localTradeSelections: string;
  subOffices?: {
    address?: string;
    city?: string;
    province?: string;
    postalCode?: string;
  }[];
}

export interface Province {
  id: string;
  name: string;
  code?: string;
  created_at?: string;
  updated_at?: string;
}

export const initialMechanicalContractorFormData: MechanicalContractorFormData = {
  name: '',
  status: 'active',
  address: '',
  city: '',
  province: '',
  postalCode: '',
  coordinates: [],
  subOffices: [],
  localTradeSelections: []
};

export const initialMechanicalContractorFormErrors: MechanicalContractorFormErrors = {
  name: '',
  status: '',
  address: '',
  city: '',
  province: '',
  postalCode: '',
  localTradeSelections: ''
};

export const statusOptions = [
  { value: 'active', label: 'Active' },
  { value: 'inactive', label: 'Inactive' }
];